angular.module('hcap-analytics')
.controller('CsmAdminCtrl', [
  '$scope',
  '$stateParams',
  '$uibModal',
  'SurveyBundleService',
  'AlertService',
  'PortalsService',
  function(
    $scope,
    $stateParams,
    $uibModal,
    SurveyBundleService,
    AlertService,
    PortalsService,
  ) {
    $scope.data = {
      portal: $stateParams.portal || 'CSM',
      portalName: '',
      loaded: false,
      error: false,
      status: null,
      busy: {},
    };

    PortalsService.get($scope.data.portal).then(portal => {
      $scope.data.portalName = portal.name;
    });

    function load() {
      return SurveyBundleService.getAdminStatus($stateParams.cohortId, $stateParams.token).then(status => {
        $scope.data.status = status;
        $scope.data.loaded = true;
      }).catch(() => {
        $scope.data.loaded = true;
        $scope.data.error = true;
      });
    }

    $scope.resendBundleInvitation = function(participant) {
      if ($scope.data.busy[participant._id]) {
        return;
      }

      $scope.data.busy[participant._id] = true;
      SurveyBundleService.resendBundleInvitation($stateParams.cohortId, $stateParams.token, participant._id).then(() => {
        AlertService.alert('Bundle invitation resent.');
      }).finally(() => {
        $scope.data.busy[participant._id] = false;
      });
    };

    $scope.resendRaters = function(participant) {
      if (!participant.bundleParticipantGuid || $scope.data.busy[participant.bundleParticipantGuid + 'raters']) {
        return;
      }

      $scope.data.busy[participant.bundleParticipantGuid + 'raters'] = true;
      SurveyBundleService.resendRaters($stateParams.cohortId, $stateParams.token, participant.bundleParticipantGuid).then(res => {
        AlertService.alert(`${res.count} reminder email${res.count === 1 ? '' : 's'} resent.`);
        return load();
      }).finally(() => {
        $scope.data.busy[participant.bundleParticipantGuid + 'raters'] = false;
      });
    };

    $scope.manageRaters = function(participant) {
      $uibModal.open({
        templateUrl: 'templates/partials/_csmRaterManager.html',
        controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
          $scope.data = {
            participant,
            bundleBusy: false,
            raterBusy: false,
          };

          $scope.resendBundleInvitation = function() {
            if ($scope.data.bundleBusy) {
              return;
            }

            $scope.data.bundleBusy = true;
            SurveyBundleService.resendBundleInvitation($stateParams.cohortId, $stateParams.token, participant._id).then(() => {
              AlertService.alert('Bundle invitation resent.');
            }).finally(() => {
              $scope.data.bundleBusy = false;
            });
          };

          $scope.resendRaters = function() {
            if (
              $scope.data.raterBusy ||
              !participant.bundleParticipantGuid ||
              participant.ratersCompleted === participant.ratersInvited
            ) {
              return;
            }

            $scope.data.raterBusy = true;
            SurveyBundleService.resendRaters($stateParams.cohortId, $stateParams.token, participant.bundleParticipantGuid).then(res => {
              AlertService.alert(`${res.count} reminder email${res.count === 1 ? '' : 's'} resent.`);
              return load();
            }).then(() => {
              $uibModalInstance.close();
            }).finally(() => {
              $scope.data.raterBusy = false;
            });
          };

          $scope.close = function() {
            $uibModalInstance.dismiss('cancel');
          };
        }],
      });
    };

    load();
  },
]);
